import { YStack, Text, styled } from 'tamagui'
import { Button } from '../ui'
import { copy } from '../../content/copy'

const Section = styled(YStack, {
  name: 'SecondaryCTASection',
  paddingHorizontal: '$6',
  paddingVertical: '$16',
  backgroundColor: '$backgroundSecondary',
  alignItems: 'center',

  '$md': {
    paddingHorizontal: '$4',
    paddingVertical: '$10',
  },
})

const Container = styled(YStack, {
  name: 'Container',
  maxWidth: 700,
  width: '100%',
  alignItems: 'center',
  gap: '$8',
})

const QuestionHeadline = styled(Text, {
  name: 'QuestionHeadline',
  // @ts-ignore - Tamagui's `render` controls the underlying HTML element on web
  render: 'h2',
  fontFamily: '$heading',
  fontSize: '$9',
  fontWeight: '600',
  color: '$textPrimary',
  textAlign: 'center',

  '$md': {
    fontSize: '$7',
  },
  '$sm': {
    fontSize: '$6',
  },
})

interface SecondaryCTASectionProps {
  onCtaClick?: () => void
}

export function SecondaryCTASection({ onCtaClick }: SecondaryCTASectionProps) {
  const { question, cta } = copy.secondaryCta

  return (
    <Section>
      <Container>
        <QuestionHeadline>{question}</QuestionHeadline>

        <Button variant="primary" size="xl" onPress={onCtaClick}>
          {cta}
        </Button>
      </Container>
    </Section>
  )
}
